import React from 'react';
import { Zap } from 'lucide-react';

export interface SlashCommand {
  command: string;
  name: string;
  description: string;
}

interface Props {
  commands: SlashCommand[];
  loading: boolean;
  highlightedIndex: number;
  onSelect: (command: SlashCommand) => void;
  onHighlight: (index: number) => void;
}

const SlashCommandsDropdown: React.FC<Props> = ({
  commands,
  loading,
  highlightedIndex,
  onSelect,
  onHighlight,
}) => {
  if (!loading && commands.length === 0) return null;

  return (
    <div
      role="listbox"
      className="absolute left-0 right-0 mb-4px overflow-y-auto bg-surface-1 border-gray-200 rounded-md" style={{ bottom: '100%', maxHeight: 260, boxShadow: 'var(--shadow-lg)', zIndex: 9999, padding: 'var(--space-1) 0' }}
    >
      {loading && commands.length === 0 ? (
        <div className="px-3-py-2 text-xs text-gray-500">
          Загрузка команд...
        </div>
      ) : (
        commands.map((cmd, idx) => (
          <button
            key={cmd.command}
            type="button"
            role="option"
            aria-selected={idx === highlightedIndex}
            onMouseDown={e => e.preventDefault()}
            onMouseEnter={() => onHighlight(idx)}
            onClick={() => onSelect(cmd)}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 'var(--space-2)',
              width: '100%',
              textAlign: 'left',
              padding: 'var(--space-2) var(--space-3)',
              fontSize: 'var(--text-sm)',
              border: 'none',
              cursor: 'pointer',
              background: idx === highlightedIndex ? 'var(--primary-50)' : 'transparent',
              color: 'var(--gray-800)',
              fontFamily: 'inherit',
            }}
          >
            <Zap size={14} className="flex-shrink-0 mt-2px text-primary-500" />
            <div className="min-w-0">
              <div className="font-medium">
                <span className="text-primary-600">{cmd.command}</span>
                <span className="text-gray-400 ml-2 font-normal">
                  {cmd.name}
                </span>
              </div>
              <div className="text-xs text-gray-500 mt-2px overflow-hidden text-ellipsis" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                {cmd.description}
              </div>
            </div>
          </button>
        ))
      )}
    </div>
  );
};

export default SlashCommandsDropdown;
